import { useState, useEffect } from 'react';

import { _ComponentTypeConstants, _ProductTypeConstants } from '../../../../core/services/dataBean/EntityCatalogVdos';
import useDataBean from '../../../../core/services/dataBean/useDataBean';




interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const ProductTypeConstantsSelect = ({ idSelector, onChange, label }: Props) => {

    const comp = useDataBean(_ProductTypeConstants);
    const [lista, setLista] = useState<any[]>([]);
    const [id, setID] = useState<number>(idSelector);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector !== id) {
            setID(idSelector);
            ////console.log(idSelector)
        }
    }, [idSelector]);

    const setValue = (e: any) => {
        const selectedID = parseInt(e);
        onChange(selectedID);
    };

    const getLista = () => {
        comp.instance.getHealthProductTypeConstants(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);
                }
            }
        );
    };

    return (
        <>
            <label>{label ?? "Tipo:"}</label>
            <select className="form-select" value={id} onChange={(e) => setValue(e.target.value)}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => (
                        <option key={index} value={item.DataBeanProperties.Value}>
                            {item.DataBeanProperties.Property}
                        </option>
                    ))
                }
            </select>
        </>
    );
};
